import React from 'react';
import Button from "../form_components/Button";
import TestToolNodeSubCon from "../form_components/submenu_contents/TestToolNodeSubCon";
import CanvasTabManager from "../utilities/CanvasTabManager";

export default class ResponseListGroup extends React.Component {

    constructor(props) {
        super(props);
        this.handleNodeClick = this.handleNodeClick.bind(this);
    }

    handleNodeClick(event) {
        const nodeId = event.currentTarget.id;
        const modules = window.apm.serialized.components.modules;
        for (let i = 0; i < modules.length; i++) {
            const module = modules[i];
            if (module.versions[module.version]) {
                for (let j = 0; j < module.versions[module.version].flow.nodes.length; j++) {
                    const n = module.versions[module.version].flow.nodes[j];
                    if (n.id === nodeId) {
                        $('a[href="#"]')[0].click();
                        CanvasTabManager.addTab(module);
                        setTimeout(() => {
                            window.apm.postEventToCurrentView({
                                target: "request-select-matching",
                                event: { id: n.id, type: n.type }
                            });
                        }, 100);
                        return;
                    }
                }
            }
        }
    }

    getNodesView(nodes) {
        return <div className="group">
            {
                Object.values(nodes).map(node => {
                    return <div
                        key={node.id}
                        id={node.id}
                        className="group-item"
                        onClick={this.handleNodeClick}
                    >
                        <span>{node.name}</span>
                        {
                            (node.input || node.output) && <Button
                                label="I/O"
                                type={"tag"}
                                callback={"__submenu"}
                                context={this}
                                submenu={TestToolNodeSubCon}
                                menuParams={{ node: node }}
                            />
                        }
                    </div>
                })
            }
        </div>;
    }

    render() {
        const request = this.props.listItem.request;
        const response = this.props.listItem.response;
        const filter = this.props.filter;
        const filterInfo = this.props.filterInfo;
        const nodes = {};
        if (response.graphEvents) {
            response.graphEvents.forEach(ge => {
                if (ge.type === "nodeEnterEvent" || ge.type === "nodeExitEvent") {
                    if (!nodes[ge.id]) {
                        nodes[ge.id] = {
                            id: ge.id,
                            name: ge.name,
                            input: null,
                            output: null
                        };
                    }
                    if (ge.inputs && ge.inputs.length) {
                        nodes[ge.id].input = JSON.stringify(ge.inputs, null, 4);
                    }
                    if (ge.outputs && ge.outputs.length) {
                        nodes[ge.id].output = JSON.stringify(ge.outputs, null, 4);
                    }
                }
            });
        }
        return (
            <div className="responseListGroup">
                {(filter["unitTest"] && response.unitTestStatus && response.unitTestStatus.type === "start") &&
                <div className="item unitTest" key={`${this.props.keyIdx}_unitTestStart`}>
                    <span className={"title"}><i className={"fe " + filterInfo["unitTest"].iconClass} />UNIT_TEST</span>
                    <span className={"content"}>{response.unitTestStatus.message}</span>
                </div>
                }
                {filter["intent"] && request.type === "recognition" &&
                request.recognition.intents.map((intent, idx) => {
                    return (
                        <div className="item intent" key={`${this.props.keyIdx}_${idx}_intent`}>
                            <span className={"title"}><i className={"fe " + filterInfo["intent"].iconClass} />{intent.name}</span>
                            <span className={"content"}>{intent.value}</span>
                        </div>
                    )
                })
                }
                {filter["error"] && request.type === "error" &&
                <div className="item error" key={`${this.props.keyIdx}_error`}>
                    <span className={"title"}><i className={"fe " + filterInfo["error"].iconClass} />{filterInfo["error"].name}</span>
                    <span className={"content"}>{request.errorCode}</span>
                </div>
                }
                {filter["error"] && response.errorMessage &&
                <div className="item error" key={`${this.props.keyIdx}_error`}>
                    <span className={"title"}><i className={"fe " + filterInfo["error"].iconClass} />{filterInfo["error"].name}</span>
                    <span className={"content"}>{response.errorMessage}</span>
                </div>
                }
                {filter["reportTag"] && response.reportTags &&
                response.reportTags.map((tag, idx) => {
                    return (
                        <div className="item reportTag" key={`${this.props.keyIdx}_${idx}_reportTag`}>
                            <span className={"title"}><i className={"fe " + filterInfo["reportTag"].iconClass} />{tag.name}</span>
                            <span className={"content"}>{tag.data}</span>
                        </div>
                    )
                })
                }
                {filter["prompt"] && response.prompts &&
                response.prompts.map((prompt, idx) => {
                    return (
                        <div className="item prompt" key={`${this.props.keyIdx}_${idx}_prompt`}>
                            <span className={"title"}><i className={"fe " + filterInfo["prompt"].iconClass} />{prompt.name}</span>
                            <span className={"content"}>{prompt.transcript}</span>
                        </div>
                    )
                })
                }
                {(filter["unitTest"] && response.unitTestError) &&
                <div className="item error" key={`${this.props.keyIdx}_unitTestError`}>
                    <span className={"title"}><i className={"fe " + filterInfo["unitTest"].iconClass} />UNIT_TEST</span>
                    <span className={"content"}>{response.unitTestError.message}</span>
                </div>
                }
                {(filter["nodes"] && Object.values(nodes).length > 0) &&
                <div className="item nodes" key={`${this.props.keyIdx}_nodes`}>
                    <span className={"title"}><i className={"fe " + filterInfo["nodes"].iconClass} />{filterInfo["nodes"].name}</span>
                    <span className={"content"}>{this.getNodesView(nodes)}</span>
                </div>
                }
                {filter["dsid"] && response.type === 'input' &&
                <div className="item dsid" key={`${this.props.keyIdx}_input`}>
                    <span className={"title"}><i className={"fe " + filterInfo["dsid"].iconClass} />{filterInfo["dsid"].name}</span>
                    <span className={"content"}>{response.input.id + ((response.input.config && response.input.config.noInputTimeout) ? ` (timeout: ${response.input.config.noInputTimeout.toLocaleString()} ms)` : "")}</span>
                </div>
                }
                {filter["waitPrompt"] && response.type === 'output' && response.waitPrompt &&
                <div className="item waitPrompt" key={`${this.props.keyIdx}_output`}>
                    <span className={"title"}><i className={"fe " + filterInfo["waitPrompt"].iconClass} />{response.waitPrompt.name}</span>
                    <span className={"content"}>{response.waitPrompt.transcript}</span>
                </div>
                }
                {(filter["unitTest"] && response.unitTestStatus && response.unitTestStatus.type === "end") &&
                <div className="item unitTest" key={`${this.props.keyIdx}_unitTestEnd`}>
                    <span className={"title"}><i className={"fe " + filterInfo["unitTest"].iconClass} />UNIT_TEST</span>
                    <span className={"content"}>{response.unitTestStatus.message}</span>
                </div>
                }
            </div>
        )
    }
}